module.exports = "query trackingNumbers{trackingNumbers{orderNumber trackingNumber shippingService}}"